<template>
  <div class="bg-grey-lines block-fullscreen">
    <div class="header-logo">
      <icon name="td-logo" color="#393f49" />
    </div>
    <section class="block-fullscreen-center">
      <questions title="CULTURA E LIDERANÇA" :items='questions' :key-form='keyForm'
        prev="/teste" next="/teste/agilidade-operacional" />
    </section>
  </div>
</template>

<script>
import Icon from '../Icon';
import Questions from './Questions';

/* eslint-disable max-len */
export default {
  name: 'cultura_e_lideranca-form',
  components: { Icon, Questions },
  data() {
    return {
      keyForm: 'cultura_e_lideranca',
      questions: this.$store.state.questions.cultura_e_lideranca,
    };
  },
  mounted() {
    this.$store.commit('SET_BAR_PROGRESS', 2);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/test/CultureAndLeadershipForm.vue